import { axiosInstance } from "./axiosInstance";

export const doctorService = {
    getDoctor: async ( filters ) => {
        return await axiosInstance.get('/api/superadmin/doctor', { params: filters })
    },
    createDoctor: async (data) => {
        return await axiosInstance.post('/api/superadmin/doctor/create', data)
    },
    updateDoctor: async (id, data) => {
        return await axiosInstance.post(`/api/superadmin/doctor/update/${id}`, data)
    },
    deleteDoctor: async (id) => {
        return await axiosInstance.delete(`/api/superadmin/doctor/delete/${id}`)
    }
}